import React from 'react';

const CorrectSymbol = () => {
	return (
		<>
			<div className="correct-symbol">&#10003;</div>
		</>
	);
};

export default CorrectSymbol;
